import React from "react";
import { Link } from "react-router-dom";
import { Flame, Snowflake } from "@phosphor-icons/react";

/**
 * Compact streak indicator for the top nav.
 *   - Shows nothing at streak 0 (don't pressure new users)
 *   - Flame number = consecutive study days
 *   - 🧊 count = banked streak freezes (earned every 7 days, max 2)
 */
export default function StreakPill({ stats }) {
  if (!stats) return null;
  const { streak = 0, freezes = 0, at_risk = false } = stats;
  if (streak <= 0) return null;

  const flameColor = at_risk
    ? "text-[color:var(--vermilion)]"
    : "text-[color:var(--flame,#f97316)]";

  return (
    <Link
      to="/profile#streak"
      className="hidden sm:inline-flex items-center gap-1.5 px-2.5 py-1 border rule bg-white hover:bg-[color:var(--surface-alt)] transition-colors"
      title={
        at_risk
          ? `Your ${streak}-day streak is at risk — study today to keep it!`
          : `${streak}-day study streak${freezes ? ` · ${freezes} freeze${freezes > 1 ? "s" : ""} banked` : ""}`
      }
      data-testid="nav-streak-pill"
    >
      <Flame size={14} weight={at_risk ? "regular" : "fill"} className={flameColor} />
      <span className="font-mono text-xs tabular-nums">{streak}</span>
      {freezes > 0 && (
        <>
          <span className="text-[color:var(--ink-faint)] text-xs">·</span>
          <Snowflake size={12} weight="fill" className="text-sky-500" />
          <span className="font-mono text-xs tabular-nums">{freezes}</span>
        </>
      )}
    </Link>
  );
}
